import L from 'leaflet'
import { leafletLayer as protomapsLayer } from 'protomaps-leaflet'

const DEFAULT_PMTILES_URL = 'https://tiles.loadfetcher.com/current/{z}/{x}/{y}.mvt'
const PMTILES_URL = process.env.REACT_APP_PMTILES_URL || DEFAULT_PMTILES_URL
let abortsSilenced = false

const silenceTileAborts = () => {
	if (abortsSilenced || typeof window === 'undefined') return
	abortsSilenced = true

	window.addEventListener('unhandledrejection', event => {
		if (event.reason?.name === 'AbortError') event.preventDefault()
	})
}
export const addBasemap = (map, isDarkMode) => {
	if (isDarkMode) {
		silenceTileAborts()

		protomapsLayer({
			url: PMTILES_URL,
			flavor: 'dark',
			lang: 'en',
			maxDataZoom: 14,
			maxZoom: 19,
			attribution: '© OpenStreetMap contributors © Protomaps',
		}).addTo(map)
		return
	}

	L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
		attribution: '© OpenStreetMap contributors',
		maxZoom: 19,
	}).addTo(map)
}
